/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import Swal from 'sweetalert2';

// @mui material components
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Tooltip from '@mui/material/Tooltip';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDInput from 'components/MDInput';
import MDCheckbox from 'components/MDCheckbox';
import MDSelect from 'components/MDSelect';
import TableHeader from 'components/Table/TableHeader';
import TabPanel from 'components/TabPanel/TabPanel';

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Navbar from 'examples/Navbars/NavBar';
import Footer from 'examples/Footer';
import { useTranslation } from 'react-i18next';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import { useSelector } from 'react-redux';
import * as Func from 'services/Function';
import RoleCheck from './RoleCheck';

const initAttr = {
  id: '',
  code: '',
  first_menu: '',
  name: '',
  enable: 'Y',
  created_at: '',
  updated_at: '',
};

const initFind = {
  search: '',
  order_by: 'tb.id',
  order_sort: 'desc',
  page: 1,
  perPage: 10,
  pageTotal: 0,
};

function Role() {
  const mod = 'role';
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [show, setShow] = useState(null);
  const [attr, setAttr] = useState(initAttr);
  const [find, setFind] = useState(initFind);
  const [notify, setNotify] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(initFind.order_sort);
  const [orderBy, setOrderBy] = useState(initFind.order_by);
  const [modalAdd, setModalAdd] = useState(false);
  const [tab, setTab] = useState(0);
  const [cboFirstMenu, setCboFirstMenu] = useState([]);
  const [cboMenu, setCboMenu] = useState([]);
  const [cboPermission, setCboPermission] = useState([]);
  const [cboNotify, setCboNotify] = useState([]);
  const [cboApp, setCboApp] = useState([]);
  const [cboReport, setCboReport] = useState([]);
  const [cboDashboard, setCboDashboard] = useState([]);
  const [cboAppShop, setCboAppShop] = useState([]);
  const [cboRole, setCboRole] = useState([]);
  const [attrMenu, setAttrMenu] = useState([]);
  const [attrPerm, setAttrPerm] = useState([]);
  const [attrNotify, setAttrNotify] = useState([]);
  const [attrApp, setAttrApp] = useState([]);
  const [attrReport, setAttrReport] = useState([]);
  const [attrDashboard, setAttrDashboard] = useState([]);
  const [attrAppShop, setAttrAppShop] = useState([]);
  const [roleCopy, setRoleCopy] = useState('');
  const [copyType, setCopyType] = useState('');
  const [modalCopy, setModalCopy] = useState(false);

  const openShow = (e) => setShow(e.currentTarget);
  const closeShow = () => setShow(null);

  const initHeader = [
    { id: 'tb.id', label: t(`attr.id`), align: 'center' },
    { id: 'tb.code', label: 'รหัส', align: 'center' },
    { id: 'tb.name', label: 'สิทธิ์การใช้', align: 'left' },
    { id: 'tb.first_menu', label: 'เมนูแรก', align: 'left' },
    { id: 'count_user', label: 'ผู้ใช้', align: 'right', sort: false },
    { id: 'count_menu', label: 'เมนู', align: 'right', sort: false },
    { id: 'count_report', label: 'รายงาน', align: 'right', sort: false },
    { id: 'count_perm', label: 'อนุมัติ', align: 'right', sort: false },
    { id: 'count_notify', label: 'แจ้งเตือน', align: 'right', sort: false },
    { id: 'count_app', label: 'App', align: 'right', sort: false },
    { id: 'count_app_shop', label: 'App Shop', align: 'right', sort: false },
    { id: 'count_dashboard', label: 'Dashboard', align: 'right', sort: false },
    { id: 'tb.enable', label: t(`attr.enable`), align: 'center' },
    { id: 'tb.created_at', label: t(`attr.created_at`), align: 'center' },
    { id: 'delete', label: '', align: 'center', sort: false },
  ];

  const showNotify = (msg, color) => {
    setNotify(
      <Snackbar
        open
        autoHideDuration={3000}
        onClose={() => setNotify(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={() => setNotify(null)} severity={color} variant='filled'>
          {msg}
        </Alert>
      </Snackbar>
    );
  };

  const view = (data) => {
    setFind(data);
    setLoading(true);
    setRecord([]);
    closeShow();

    FetchData('POST', `/${mod}`, app.token, {
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      ordersort: data.order_sort,
    }).then((result) => {
      if (result.status === 'ok') {
        setRecord(result.data);

        setPageTotal(result.total_pages);
        setPageNo(result.page);
      }
      setLoading(false);
    });
  };

  const open = () => {
    setLoading(true);
    setConfirm(false);
    setAttr(initAttr);
    setAttrMenu([]);
    setAttrPerm([]);
    setAttrNotify([]);
    setAttrApp([]);
    setAttrDashboard([]);
    setAttrAppShop([]);
    setTab(0);

    FetchData('GET', `/${mod}/${id}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setAttr(result.data);
        setAttrMenu(result.menu);
        setAttrPerm(result.permission);
        setAttrNotify(result.notify);
        setAttrApp(result.app);
        setAttrReport(result.report);
        setAttrDashboard(result.dashboard);
        setAttrAppShop(result.app_shop);

        setLoading(false);
      }
    });
  };

  const addConfirm = () => {
    if (!Func.verifyLength(attr.code, 1)) return;
    if (!Func.verifyLength(attr.name, 1)) return;
    if (!Func.verifyLength(attr.first_menu, 1)) return;

    setConfirm(true);
  };

  const add = () => {
    setLoading(true);
    setModalAdd(false);

    FetchData('PUT', `/${mod}`, app.token, {
      code: attr.code,
      name: attr.name,
      first_menu: attr.first_menu,
      enable: attr.enable,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        view(find);
        showNotify(t(`alert.addcomplete`), 'success');
      } else {
        setModalAdd(true);
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const editConfirm = () => {
    if (!Func.verifyLength(attr.code, 1)) return false;
    if (!Func.verifyLength(attr.name, 1)) return false;
    if (!Func.verifyLength(attr.first_menu, 1)) return false;

    return true;
  };

  const edit = () => {
    if (!editConfirm()) return;

    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);

        FetchData('PATCH', `/${mod}/${attr.id}`, app.token, {
          code: attr.code,
          name: attr.name,
          first_menu: attr.first_menu,
          enable: attr.enable,
        }).then((result) => {
          setLoading(false);

          if (result.status === 'ok') {
            open();
            showNotify(t(`alert.editcomplete`), 'success');
          } else {
            showNotify(t(`alert.saveerror`), 'error');
          }
        });
      }
    });
  };

  const copyTo = () => {
    if (roleCopy === '') return;

    setConfirm(false);
    setModalCopy(false);
    setLoading(true);

    FetchData('OPTIONS', `/${mod}/copyto`, app.token, {
      id: id,
      type: copyType,
      copy_id: roleCopy,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        showNotify(t(`alert.editcomplete`), 'success');
      } else {
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const checkMenu = (menu_id, check) => {
    FetchData('OPTIONS', `/${mod}/checkmenu`, app.token, {
      role_id: id,
      menu_id: menu_id,
      enable: check ? 'Y' : 'N',
    }).then((result) => {
      if (result.status !== 'ok') {
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const checkPerm = (permission_id, check) => {
    FetchData('OPTIONS', `/${mod}/checkperm`, app.token, {
      role_id: id,
      permission_id: permission_id,
      enable: check ? 'Y' : 'N',
    }).then((result) => {
      if (result.status !== 'ok') {
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const checkNotify = (notify_id, check) => {
    FetchData('OPTIONS', `/${mod}/checknotify`, app.token, {
      role_id: id,
      notify_id: notify_id,
      enable: check ? 'Y' : 'N',
    }).then((result) => {
      if (result.status !== 'ok') {
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const checkApp = (app_id, check) => {
    FetchData('OPTIONS', `/${mod}/checkapp`, app.token, {
      role_id: id,
      app_id: app_id,
      enable: check ? 'Y' : 'N',
    }).then((result) => {
      if (result.status !== 'ok') {
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const checkReport = (report_id, check) => {
    FetchData('OPTIONS', `/${mod}/checkreport`, app.token, {
      role_id: id,
      report_id: report_id,
      enable: check ? 'Y' : 'N',
    }).then((result) => {
      if (result.status !== 'ok') {
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const checkDashboard = (dashboard_id, check) => {
    FetchData('OPTIONS', `/${mod}/checkdashboard`, app.token, {
      role_id: id,
      dashboard_id: dashboard_id,
      enable: check ? 'Y' : 'N',
    }).then((result) => {
      if (result.status !== 'ok') {
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const checkAppShop = (app_shop_id, check) => {
    FetchData('OPTIONS', `/${mod}/checkappshop`, app.token, {
      role_id: id,
      app_shop_id: app_shop_id,
      enable: check ? 'Y' : 'N',
    }).then((result) => {
      if (result.status !== 'ok') {
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const editMenu = () => {
    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);
        setConfirm(false);

        FetchData('OPTIONS', `/${mod}/editmenu`, app.token, {
          id: attr.id,
          data: attrMenu,
        }).then((result) => {
          setLoading(false);

          if (result.status === 'ok') {
            showNotify(t(`alert.editcomplete`), 'success');
          } else {
            showNotify(t(`alert.saveerror`), 'error');
          }
        });
      }
    });
  };

  const editPerm = () => {
    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);
        setConfirm(false);

        FetchData('OPTIONS', `/${mod}/editpermission`, app.token, {
          id: attr.id,
          data: attrPerm,
        }).then((result) => {
          setLoading(false);

          if (result.status === 'ok') {
            showNotify(t(`alert.editcomplete`), 'success');
          } else {
            showNotify(t(`alert.saveerror`), 'error');
          }
        });
      }
    });
  };

  const editNotify = () => {
    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);
        setConfirm(false);

        FetchData('OPTIONS', `/${mod}/editnotify`, app.token, {
          id: attr.id,
          data: attrNotify,
        }).then((result) => {
          setLoading(false);

          if (result.status === 'ok') {
            showNotify(t(`alert.editcomplete`), 'success');
          } else {
            showNotify(t(`alert.saveerror`), 'error');
          }
        });
      }
    });
  };

  const editApp = () => {
    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);
        setConfirm(false);

        FetchData('OPTIONS', `/${mod}/editapp`, app.token, {
          id: attr.id,
          data: attrApp,
        }).then((result) => {
          setLoading(false);

          if (result.status === 'ok') {
            showNotify(t(`alert.editcomplete`), 'success');
          } else {
            showNotify(t(`alert.saveerror`), 'error');
          }
        });
      }
    });
  };

  const copy = () => {
    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);

        FetchData('OPTIONS', `/${mod}/copy`, app.token, {
          id: id,
        }).then((result) => {
          if (result.status === 'ok') {
            window.location.replace(`/${mod}/${result.id}`);
            showNotify(t(`alert.addcomplete`), 'success');
          } else {
            setLoading(false);
            showNotify(t(`alert.saveerror`), 'error');
          }
        });
      }
    });
  };

  const del = (item) => {
    Swal.fire({
      title: t(`alert.confirm_delete_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.deleteconfirm`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);

        FetchData('DELETE', `/${mod}/${item.id}`, app.token, {}).then((result) => {
          setLoading(false);

          if (result.status === 'ok') {
            view(find);
            showNotify(t(`alert.deletecomplete`), 'success');
          } else {
            showNotify(t(`alert.deleteerror`), 'error');
          }
        });
      }
    });
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  const renderShow = (
    <Menu
      anchorEl={show}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      open={Boolean(show)}
      onClose={closeShow}
      keepMounted
    >
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 10 })}>
        {t(`element.show_record`, { num: 10 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 20 })}>
        {t(`element.show_record`, { num: 20 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 100 })}>
        {t(`element.show_record`, { num: 100 })}
      </MenuItem>
    </Menu>
  );

  const handleSort = (e, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);

    view({ ...find, order_by: property, order_sort: isAsc ? 'desc' : 'asc' });
  };

  const init = () => {
    FetchData('GET', `/${mod}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setAttr(initAttr);
        setCboFirstMenu(result.firstmenu);
        setCboMenu(result.menu);
        setCboPermission(result.permission);
        setCboNotify(result.notify);
        setCboApp(result.app);
        setCboReport(result.report);
        setCboDashboard(result.dashboard);
        setCboAppShop(result.app_shop);
        setCboRole(result.role);

        if (id === undefined) {
          view(find);
        } else {
          open();
        }
      } else {
        Func.exitApp();
      }
    });
  };

  const enableDisplay = (inp) => {
    if (inp === 'Y') return <Icon color='info'>verified</Icon>;
    return <Icon color='error'>not_interested</Icon>;
  };

  const btnOpen = (item) => {
    return (
      <NavLink to={`/${mod}/${item.id}`}>
        <MDButton
          variant='text'
          color='info'
          size='small'
          sx={{
            fontSize: '1rem',
            whiteSpace: 'nowrap',
            p: 0,
            display: 'inline-block',
            textAlign: 'left',
          }}
        >
          {item.code}
        </MDButton>
      </NavLink>
    );
  };

  const btnDel = (item) => {
    if (!app.perm.del) return null;

    return (
      <Tooltip title={t(`element.delete`)}>
        <MDButton variant='text' color='error' size='small' iconOnly onClick={() => del(item)}>
          <Icon>delete</Icon>
        </MDButton>
      </Tooltip>
    );
  };

  const renderSearch = () => {
    return (
      <Card sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <MDBox
              noValidate
              component='form'
              role='form'
              onSubmit={(e) => {
                e.preventDefault();
                view({ ...find, period: 'ALL', page: 1 });
              }}
            >
              <MDInput
                name='searchform'
                fullWidth
                value={find.search}
                type='search'
                onChange={(e) => setFind({ ...find, search: e.target.value, page: 1 })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>{t('element.search')} :</InputAdornment>
                  ),
                  autoComplete: 'off',
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
      </Card>
    );
  };

  const renderList = () => {
    return (
      <MDBox mb={7}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={9} md={10} lg={11}>
            {renderSearch()}
          </Grid>
          <Grid item xs={12} sm={3} md={2} lg={1}>
            <MDButton
              variant='contained'
              color='dark'
              size='large'
              fullWidth
              sx={{ pt: 1.6, pb: 1.6 }}
              onClick={() => {
                setAttr(initAttr);
                setConfirm(false);
                setModalAdd(true);
              }}
            >
              <Icon>post_add</Icon>
            </MDButton>
          </Grid>
          <Grid item xs={12}>
            <TableContainer component={Paper}>
              <Table>
                <TableHeader
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleSort}
                  data={initHeader}
                />
                <TableBody>
                  {record.map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell align='center'>{row.id}</TableCell>
                      <TableCell align='left'>{btnOpen(row)}</TableCell>
                      <TableCell align='left' className='nowrap'>
                        {row.name}
                      </TableCell>
                      <TableCell align='left' className='nowrap'>
                        {row.firstmenu_name}
                      </TableCell>
                      <TableCell align='right' className='color-primary'>
                        {row.count_user}
                      </TableCell>
                      <TableCell align='right' className='color-danger'>
                        {row.count_menu}
                      </TableCell>
                      <TableCell align='right' className='color-info'>
                        {row.count_report}
                      </TableCell>
                      <TableCell align='right' className='color-success'>
                        {row.count_perm}
                      </TableCell>
                      <TableCell align='right' className='color-warning'>
                        {row.count_notify}
                      </TableCell>
                      <TableCell align='right' className='color-danger'>
                        {row.count_app}
                      </TableCell>
                      <TableCell align='right' className='color-success'>
                        {row.count_app_shop}
                      </TableCell>
                      <TableCell align='right' className='color-info'>
                        {row.count_dashboard}
                      </TableCell>
                      <TableCell align='center'>{enableDisplay(row.enable)}</TableCell>
                      <TableCell align='center' className='nowrap'>
                        {Func.dateTimeDisplay(row.created_at)}
                      </TableCell>
                      <TableCell align='center'>{btnDel(row)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <MDBox display='flex' justifyContent='space-between' alignItems='flex-start'>
                <MDButton variant={show ? 'contained' : 'outlined'} color='dark' onClick={openShow}>
                  {t(`element.show_record`, { num: find.perPage })}&nbsp;
                  <Icon>keyboard_arrow_down</Icon>
                </MDButton>
                {renderShow}
                <Pagination
                  count={pageTotal}
                  variant='outlined'
                  color='secondary'
                  showFirstButton
                  showLastButton
                  page={pageNo}
                  onChange={(e, p) => view({ ...find, page: p })}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderInfo = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MDInput
            label='รหัส'
            onChange={(e) => setAttr({ ...attr, code: e.target.value })}
            value={attr.code}
            variant='standard'
            fullWidth
            inputProps={{
              autoComplete: 'off',
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <MDInput
            label='สิทธิ์การใช้งาน'
            onChange={(e) => setAttr({ ...attr, name: e.target.value })}
            value={attr.name}
            variant='standard'
            fullWidth
            inputProps={{
              autoComplete: 'off',
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <MDSelect
            label='เมนูแรก'
            labelDefault={t(`element.please_select`)}
            data={cboFirstMenu}
            value={attr.first_menu}
            onChange={(e) => setAttr({ ...attr, first_menu: e.target.value })}
            inputProps={{
              autoComplete: 'off',
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <MDCheckbox
            label={`${t(`attr.enable`)}`}
            checked={attr.enable === 'Y'}
            onChange={(e) => setAttr({ ...attr, enable: e.target.checked ? 'Y' : 'N' })}
          />
        </Grid>
      </Grid>
    );
  };

  const renderAdd = () => {
    return (
      <Dialog open={modalAdd} maxWidth='xs' keepMounted aria-describedby='dialog-add' fullWidth>
        <DialogTitle>
          {t(`element.add`)}
          <IconButton
            aria-label='close'
            onClick={() => setModalAdd(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>{renderInfo()}</MDBox>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='outlined' color='success' onClick={add}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant='text' color='info' onClick={addConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderInfoEdit = () => {
    return (
      <MDBox sx={{ padding: 2, marginBottom: 2 }}>
        {renderInfo()}

        <Grid container mt={3}>
          <Grid item xs={12} display='flex' justifyContent='flex-end' gap={1}>
            <MDButton variant='outlined' color='success' onClick={edit}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderNavigate = () => {
    return (
      <Card sx={{ p: 2 }}>
        <Grid container>
          <Grid item xs={12}>
            <NavLink to={`/${mod}`}>
              <MDButton variant='contained' color='dark'>
                <Icon>arrow_back</Icon>&nbsp;{t(`element.back`)}
              </MDButton>
            </NavLink>
          </Grid>
        </Grid>
      </Card>
    );
  };

  const renderOpen = () => {
    return (
      <MDBox mb={7}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {renderNavigate()}
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Card sx={{ p: 2 }}>
              <MDBox sx={{ width: '100%' }}>
                <MDBox>
                  <Tabs
                    value={tab}
                    onChange={(e, v) => {
                      setTab(v);
                      setConfirm(false);
                    }}
                    aria-label='tabs-addedit'
                  >
                    <Tab label={t(`element.info`)} />
                    <Tab label='เมนู' />
                    <Tab label='รายงาน' />
                    <Tab label='อนุมัติ' />
                    <Tab label='แจ้งเตือน' />
                    <Tab label='Application' />
                    <Tab label='Application V2' />
                    <Tab label='Dashboard' />
                  </Tabs>
                </MDBox>
                <TabPanel value={tab} index={0}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={8} lg={4}>
                      <MDBox className='card'>{renderInfoEdit()}</MDBox>
                    </Grid>
                  </Grid>
                </TabPanel>
                <TabPanel value={tab} index={1}>
                  <MDBox display='flex' justifyContent='end' gap={1} mb={2}>
                    <MDButton
                      variant='gradient'
                      color='primary'
                      onClick={() => {
                        setCopyType('menu');
                        setRoleCopy('');
                        setModalCopy(true);
                      }}
                    >
                      <Icon>content_copy</Icon>&nbsp;{t(`element.copy`)}
                    </MDButton>
                  </MDBox>
                  <RoleCheck checkList={cboMenu} checkValue={attrMenu} setValue={checkMenu} />
                </TabPanel>
                <TabPanel value={tab} index={2}>
                  <MDBox display='flex' justifyContent='end' gap={1} mb={2}>
                    <MDButton
                      variant='gradient'
                      color='info'
                      onClick={() => {
                        setCopyType('report');
                        setRoleCopy('');
                        setModalCopy(true);
                      }}
                    >
                      <Icon>content_copy</Icon>&nbsp;{t(`element.copy`)}
                    </MDButton>
                  </MDBox>
                  <RoleCheck checkList={cboReport} checkValue={attrReport} setValue={checkReport} />
                </TabPanel>
                <TabPanel value={tab} index={3}>
                  <MDBox display='flex' justifyContent='end' gap={1} mb={2}>
                    <MDButton
                      variant='gradient'
                      color='warning'
                      onClick={() => {
                        setCopyType('perm');
                        setRoleCopy('');
                        setModalCopy(true);
                      }}
                    >
                      <Icon>content_copy</Icon>&nbsp;{t(`element.copy`)}
                    </MDButton>
                  </MDBox>
                  <RoleCheck checkList={cboPermission} checkValue={attrPerm} setValue={checkPerm} />
                </TabPanel>
                <TabPanel value={tab} index={4}>
                  <MDBox display='flex' justifyContent='end' gap={1} mb={2}>
                    <MDButton
                      variant='gradient'
                      color='error'
                      onClick={() => {
                        setCopyType('notify');
                        setRoleCopy('');
                        setModalCopy(true);
                      }}
                    >
                      <Icon>content_copy</Icon>&nbsp;{t(`element.copy`)}
                    </MDButton>
                  </MDBox>
                  <RoleCheck checkList={cboNotify} checkValue={attrNotify} setValue={checkNotify} />
                </TabPanel>
                <TabPanel value={tab} index={5}>
                  <MDBox display='flex' justifyContent='end' gap={1} mb={2}>
                    <MDButton
                      variant='gradient'
                      color='success'
                      onClick={() => {
                        setCopyType('app');
                        setRoleCopy('');
                        setModalCopy(true);
                      }}
                    >
                      <Icon>content_copy</Icon>&nbsp;{t(`element.copy`)}
                    </MDButton>
                  </MDBox>
                  <RoleCheck checkList={cboApp} checkValue={attrApp} setValue={checkApp} />
                </TabPanel>
                <TabPanel value={tab} index={6}>
                  <MDBox display='flex' justifyContent='end' gap={1} mb={2}>
                    <MDButton
                      variant='gradient'
                      color='secondary'
                      onClick={() => {
                        setCopyType('app_shop');
                        setRoleCopy('');
                        setModalCopy(true);
                      }}
                    >
                      <Icon>content_copy</Icon>&nbsp;{t(`element.copy`)}
                    </MDButton>
                  </MDBox>
                  <RoleCheck
                    checkList={cboAppShop}
                    checkValue={attrAppShop}
                    setValue={checkAppShop}
                  />
                </TabPanel>
                <TabPanel value={tab} index={7}>
                  <MDBox display='flex' justifyContent='end' gap={1} mb={2}>
                    <MDButton
                      variant='gradient'
                      color='dark'
                      onClick={() => {
                        setCopyType('dashboard');
                        setRoleCopy('');
                        setModalCopy(true);
                      }}
                    >
                      <Icon>content_copy</Icon>&nbsp;{t(`element.copy`)}
                    </MDButton>
                  </MDBox>
                  <RoleCheck
                    checkList={cboDashboard}
                    checkValue={attrDashboard}
                    setValue={checkDashboard}
                  />
                </TabPanel>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderCopy = () => {
    return (
      <Dialog open={modalCopy} maxWidth='xs' keepMounted aria-describedby='dialog-edit' fullWidth>
        <DialogTitle>
          {copyType === 'menu'
            ? 'คัดลอกเมนูไปยังสิทธิ์อื่น'
            : copyType === 'report'
            ? 'คัดลอกรายงานไปยังสิทธิ์อื่น'
            : copyType === 'perm'
            ? 'คัดลอกการอนุมัติไปยังสิทธิ์อื่น'
            : copyType === 'notify'
            ? 'คัดลอกการแจ้งเตือนไปยังสิทธิ์อื่น'
            : copyType === 'app'
            ? 'คัดลอก Application ไปยังสิทธิ์อื่น'
            : copyType === 'app_shop'
            ? 'คัดลอก Application V2 ไปยังสิทธิ์อื่น'
            : copyType === 'dashboard'
            ? 'คัดลอก Dashboard ไปยังสิทธิ์อื่น'
            : ''}

          <IconButton
            aria-label='close'
            onClick={() => setModalCopy(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDSelect
            label='สิทธิ์การใช้งาน'
            labelDefault={t(`element.please_select`)}
            data={cboRole}
            value={roleCopy}
            onChange={(e) => setRoleCopy(e.target.value)}
            inputProps={{
              autoComplete: 'off',
            }}
          />
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='outlined' color='success' onClick={copyTo}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton
              variant='text'
              color='success'
              onClick={() => {
                if (roleCopy !== '') setConfirm(true);
              }}
            >
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderPage = () => {
    if (id === undefined) return renderList();
    return renderOpen();
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    init();
  }, [id]);

  return (
    <DashboardLayout>
      <Navbar route={[t(`menu.user`), t(`menu.role`)]} />
      {renderPage()}
      {renderAdd()}
      {renderCopy()}
      <Footer />
      {renderLoading()}
      {notify}
    </DashboardLayout>
  );
}

export default Role;
